// extracted by mini-css-extract-plugin
export var dropdownIcon = "_pb-6";
export var imgContainer = "_pb-3";
export var menuIcon = "_pb-5";
export var pillWrapper = "_pb-2";
export var pillsContainer = "_pb-1";
export var subscriptionCard = "_pb-0";
export var subscriptionLogo = "_pb-4";